import request from "@/utils/request";

// 列表(主数据列表)
export function loadAppConsumerListDataApi(data) {
  return request({
    url: "web/appConsumer/listData",
    method: "post",
    data
  });
}

// 导出(主数据列表)
export function loadAppConsumerExportDataApi(data) {
  return request({
    url: "web/appConsumer/exportData",
    method: "post",
    data
  });
}

// 根据条件查询数量
export function findAppConsumerCountByConditionApi(data) {
  return request({
    url: "web/appConsumer/findCountByCondition",
    method: "post",
    data
  });
}

// 根据条件查询用户
export function findAppConsumerByConditionApi(data) {
  return request({
    url: "web/appConsumer/findByCondition",
    method: "post",
    data
  });
}

// 初始化
export function initAppConsumerApi(data) {
  return request({
    url: "web/appConsumer/init",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateAppConsumerApi(data) {
  return request({
    url: "web/appConsumer/saveOrUpdate",
    method: "post",
    data
  });
}

// 用户积分数据
export function listAppConsumerIntegralListDataApi(data) {
  return request({
    url: "web/appConsumerIntegral/listSelectData",
    method: "post",
    data
  });
}